module.exports = __webpack_public_path__ + "media/src/pages/MyAccount/Payments/images/amex-2b51610064150848c0dee9b5a608d41a.svg";